interface DrugQuantity {
    drugId: string;
    drugName: string;
    quantityAccordingToUser: number;
}

interface DrugQuantitiesViewSlice {
    drugQuantitiesView: {
        drugQuantities: DrugQuantity[];
        setDrugQuantities: (drugQuantities: DrugQuantity[]) => void;
        resetDrugQuantities: () => void;
    };
}

const createDrugQuantitiesViewSlice = (set: any) => ({
    drugQuantitiesView: {
        drugQuantities: [] as DrugQuantity[],
        setDrugQuantities: (drugQuantities: DrugQuantity[]) =>
            set((state: any) => ({
                drugQuantitiesView: {
                    ...state.drugQuantitiesView,
                    drugQuantities,
                },
            })),
        resetDrugQuantities: () =>
            set((state: any) => ({
                drugQuantitiesView: {
                    ...state.drugQuantitiesView,
                    drugQuantities: [],
                },
            })),
    },
});

export { createDrugQuantitiesViewSlice };
export type { DrugQuantitiesViewSlice };
